import React from 'react';
import PropTypes from 'prop-types';

class VetTecApprovedProgramsList extends React.Component {
  renderProgramList = () => {
    const { programs } = this.props;
    return (
      <ul>
        {programs.map((program, index) => {
          return (
            <li
              key={`${program.description}-${index}`}
              className="program-description"
            >
              {program.description}
            </li>
          );
        })}
      </ul>
    );
  };

  render() {
    const { programs } = this.props;
    if (programs && programs.length) {
      return (
        <div className="vads-u-margin-top--2">
          <span>
            The following training programs are approved for VET TEC 2.0:
          </span>
          <div className="vet-tec-programs-list vads-u-margin-top--4">
            {this.renderProgramList()}
          </div>
        </div>
      );
    }
    return (
      <div>
        <p>
          Program data will be available for this provider soon.{' '}
          <a
            href="/education/about-gi-bill-benefits/how-to-use-benefits/vettec-high-tech-program/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn more about VET TEC 2.0 programs
          </a>
        </p>
      </div>
    );
  }
}

VetTecApprovedProgramsList.propTypes = {
  programs: PropTypes.arrayOf(PropTypes.object),
};

export default VetTecApprovedProgramsList;
